import type { SearchAppsResponse } from '@wix/ambassador-appmarket-v1-app-market-client-aggregator/types';
import type { AppsResult } from '../../app-market-search';

export class EnhancedSearchApps {
  constructor(private readonly searchApps: SearchAppsResponse) {}

  get appIds(): string[] {
    return this.searchApps.appIds ?? [];
  }

  get hasMoreApps(): boolean {
    return this.searchApps.hasMoreApps ?? false;
  }

  get totalApps(): number {
    return this.searchApps.totalApps ?? 0;
  }

  toJSON(): AppsResult {
    return {
      appIds: this.appIds,
      hasMoreApps: this.hasMoreApps,
      totalApps: this.totalApps,
    };
  }
}
